import { render, staticRenderFns } from "./layout-product-card.vue?vue&type=template&id=1f76c83e&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./layout-product-card.vue?vue&type=script&lang=js"
export * from "./layout-product-card.vue?vue&type=script&lang=js"
import style0 from "./layout-product-card.vue?vue&type=style&index=0&id=1f76c83e&prod&lang=scss&scoped=true"
import style1 from "./layout-product-card.vue?vue&type=style&index=1&id=1f76c83e&prod&lang=scss"
import style2 from "./layout-product-card.vue?vue&type=style&index=2&id=1f76c83e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f76c83e",
  null
  
)

export default component.exports